import { render } from "./InstallWizardAlarmProfiles.vue?vue&type=template&id=342e7808"
import script from "./InstallWizardAlarmProfiles.vue?vue&type=script&lang=js"
export * from "./InstallWizardAlarmProfiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__